function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'cornflower': 'rgb(100, 149, 237)','buffalo-check': 'rgb(227, 28, 28)','chestnut': 'rgb(149, 69, 53)','river-blue': 'rgb(56, 175, 205)','forest-green': 'rgb(74, 103, 65)','wheat': 'rgb(245, 188, 81)','oatmeal': 'rgb(255, 248, 220)','sage': 'rgb(154, 171, 137)','midnight': 'rgb(0, 0, 0)','greystone': 'rgb(192, 192, 192)','wine': 'rgb(114, 47, 55)','natural': 'rgb(255, 251, 245)','navy-blue': 'rgb(0, 0, 128)','indigo': 'rgb(50, 18, 122)','rust': 'rgb(183, 65, 14)','bark': 'rgb(161, 143, 122)','blaze-orange': 'rgb(255, 103, 0)','desert-brown': 'rgb(219, 203, 184)','walnut': 'rgb(119, 63, 26)','black-grey': 'rgb(0, 0, 0)','green-grey': 'rgb(74, 103, 65)','charcoal': 'rgb(122, 122, 122)','cream': 'rgb(252, 251, 244)','ocean': 'rgb(0, 149, 187)','sandbar': 'rgb(203, 191, 173)','oatmeal-midnight': 'rgb(0, 0, 0)','bark-rust': 'rgb(183, 65, 14)',};

    this.images = {'camo': 'url("//abodeoutside.com/cdn/shop/files/Camo_120x.png?v=5472997080887356495")','colorblock-forest-green': 'url("//abodeoutside.com/cdn/shop/files/greencolorblock_120x.png?v=18145928988296825775")','colorblock-midnight': 'url("//abodeoutside.com/cdn/shop/files/blackcolorblock_120x.png?v=17540696726874817208")','urban-camo': 'url("//abodeoutside.com/cdn/shop/files/urbancamo_120x.png?v=14307520795450366097")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
